import request from "@/utils/request";
// 登录
export function login(data) {
  return request({
    url: "/api/enterprise/auth/login",
    method: "post",
    data,
  });
}
// 退出
export function logoutUser() {
  return request({
    url: "/api/enterprise/auth/logout",
    method: "post",
  });
}

// 生成二维码
export function getWeChatCode(data) {
  return request({
    url: "/api/enterprise/auth/qrcode",
    method: "POST",
    data,
  });
}

// 发送验证码
export function getVerificationCode(data) {
  return request({
    url: "/api/sms/sendSms",
    method: "POST",
    data,
  });
}

// 用户忘记密码
export function userForgetPassword(data) {
  return request({
    url: "/api/enterprise/auth/upPassword",
    method: "POST",
    data,
  });
}

// 绑定手机号注册
export function userBindingPhone(data) {
  return request({
    url: "/api/enterprise/auth/register",
    method: "POST",
    data,
  });
}
// 订阅状态（获取二维码绑定的信息）
export function getCodeBindingInfo(data) {
  return request({
    url: "/api/enterprise/auth/sub_status",
    method: "POST",
    data,
  });
}
// 解绑公众号接口
export function userUnbinding(data) {
  return request({
    url: "/api/enterprise/user/unbinding",
    method: "POST",
    data,
  });
}

// 系统订阅列表
export function getSubscriptionList(params) {
  return request({
    url: "/api/enterprise/en_sub/list",
    method: "GET",
    params,
  });
}
// 系统订阅详情
export function getSubscriptionDetails(params) {
  return request({
    url: "/api/enterprise/en_sub/get",
    method: "GET",
    params,
  });
}
// 系统订阅编辑
export function compileSubscription(data) {
  return request({
    url: "/api/enterprise/en_sub/add",
    method: "POST",
    data,
  });
}

/**
 * 企业用户管理
 * 管理员修改员工信息
 */
// 管理员查看用户信息列表
export function adminGetUserList(params) {
  return request({
    url: "/api/enterprise/user/list",
    method: "GET",
    params,
  });
}
// 管理员查看用户信息详情
export function adminGetUserDetails(params) {
  return request({
    url: "/api/enterprise/user/detail",
    method: "GET",
    params,
  });
}
// 管理员修改用户信息
export function adminUpdateUserInfo(data) {
  return request({
    url: "/api/enterprise/user/update",
    method: "POST",
    data,
  });
}
// 管理员修改用户密码
export function adminUpdateUserPassword(data) {
  return request({
    url: "/api/enterprise/user/updatePwd",
    method: "POST",
    data,
  });
}
// 管理员审核用户
export function adminAuditUser(data) {
  return request({
    url: "/api/enterprise/user/auditUser",
    method: "POST",
    data,
  });
}
// 管理员解除绑定企业接口
export function adminUnBindingUser(data) {
  return request({
    url: "/api/enterprise/user/unBindingEn",
    method: "POST",
    data,
  });
}

/**
 * 个人中心
 * 用户修改自己的信息
 */

// 修改用户信息(密码+基本信息)
export function updateUserInfo(data) {
  return request({
    url: "/api/enterprise/user/selfUpdate",
    method: "POST",
    data,
  });
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: "/api/enterprise/user/info",
    method: "GET",
    params,
  });
}

// 查询绑定企业
export function getSearchCompany(params) {
  return request({
    url: "/api/enterprise/en/search",
    method: "GET",
    params,
  });
}
// 用户绑定企业接口
export function userBindingCompany(data) {
  return request({
    url: "/api/enterprise/user/bindingEn",
    method: "POST",
    data,
  });
}


/**
 * 隐私协议
 */
export function getPrivacy(params) {
  return request({
    url: "/api/enterprise/auth/getPrivacyAgreement",
    method: "GET",
    params,
  });
}
// 权限menu
export function getUserMenu(params) {
  return request({
    url: "/api/enterprise/user/menu",
    method: "GET",
    params,
  });
}
// 左侧菜单栏
export function getNavigationMenu(params) {
  return request({
    url: "/api/enterprise/permission/menu",
    method: "GET",
    params,
  });
}

// 上传图片
export function uploadImgApi1(data) {
  return request({
    url: "/api/enterprise/upload/add",
    method: "POST",
    data,
  });
}

// 解除/关联 上级企业
export function linkOrUnlineCompany(params) {
  return request({
    url: "/api/enterprise/en/associated_enterprise",
    method: "GET",
    params,
  });
}
